import Furniture from './Furniture';

export default class Dandelion extends Furniture {
  constructor({ game, location, data }) {
    super({ game, location, data });

    this.state = data.state || 1;
    this.setAnim('0' + this.state, false);
    this.canTap = true;

    this.asset.onComplete.add(this.handleAnimComplete, this);
  }

  handleInputDown() {
    if (this.canTap) {
      this.canTap = false;
      this.state = this.state < 4 ? this.state + 1 : 2;
      this.setAnim('0' + this.state, false);

      if (this.state === 2) {
        this.game.sounds.playSFX('item_dandelion', { spriteID: 'sfx' });
      } else if (this.state === 3) {
        this.game.sounds.playSFX('item_dandelionblow', { spriteID: 'sfx' });

        //
        this.location.state.setLoopHint(this.data.hint);
      }

      //
      this.onChange.dispatch();
    }
  }

  handleAnimComplete() {
    this.canTap = true;
  }

  updateBounds() {
    this.bb = this.getBounds();
    this.bb.width = 50;
    this.bb.height = 130;
  }

  //
  serialize() {
    const data = super.serialize();
    data.state = this.state;
    return data;
  }
}
